import { toast } from "react-toastify";

export const showSuccessToast = (message: string, id: string) => {
  toast.success(message, {
    toastId: id,
    icon: <i className="bi bi-check-lg fs-3" />,
  });
};

export const showErrorToast = (message: string, id: string) => {
  toast.error(message, {
    toastId: id,
    icon: <i className="bi bi-exclamation-circle fs-3" />,
  });
};
